export default "__VITE_ASSET__CigNd$A6__"